angular.module("Main").controller("BookingPrivacyTermsDialogController", ["BookingService", "style", function (BookingService, style) {
    var vm = this;

    vm.style = style;

    BookingService.getPrivacyText().then(function (data) {
        vm.privacytermsText = data.text.PrivacyPolicy;
    })
}]);
